import { getJobPin } from './JobsOnMap';
import { get } from 'svelte/store';
import { clientSettings } from '../../../stores/api';

export class JobOnMap {
    private coords: { x: number; y: number } = { x: 0, y: 0 };
    private point: object | null = null;

    public clear() {
        if (this.point) Targeo.Base.Map.UORemove(this.point?.id);
    }

    public setCoords(x: number, y: number): void {
        this.coords.x = x;
        this.coords.y = y;
    }

    public addPoint(
        x: number,
        y: number,
        color: string,
        name: string,
        deliveryOrCollection = 'delivery'
    ): void {
        if (this.point) Targeo.Base.Map.UORemove(this.point?.id);
        this.setCoords(x, y);
        this.point = this._getMapPoint(x, y, color, name, deliveryOrCollection);
        Targeo.Base.Map.UOAdd(this.point);
    }

    private _getMapPoint(
        x: number,
        y: number,
        color: string,
        name: string,
        deliveryOrCollection = 'delivery'
    ) {
        let pinOpts = {};
        return new Targeo.MapObject.Point(
            { x, y },
            getJobPin(
                color,
                30,
                Object.assign(pinOpts, { type: deliveryOrCollection }),
                get(clientSettings).display.icon_style
            ),
            'job_',
            {
                name: name,
                zIndex: 590,
                visible: true,
                balloon: { body: name },
                mouseButtonActions: { left: function () {} },
            }
        );
    }

    public centerMap() {
        Targeo.Base.Map.zoomAndCenter({ x: this.coords.x, y: this.coords.y }, 21);
    }
}
